(function () {
  "use strict";

  HomeSeriesSidebarCtrl.$inject = ['$scope', '$rootScope', 'homeResource', 'trackingService', '$location', 'trainerPrivilege', 'seriesTraineesResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('HomeSeriesSidebarCtrl', HomeSeriesSidebarCtrl);

  function HomeSeriesSidebarCtrl($scope, $rootScope, homeResource, trackingService, $location, trainerPrivilege, seriesTraineesResource) {
    var viewState;

    var gaActions = trackingService.pages.trainerHome.actions;
    var gaPageName = trackingService.pages.trainerHome.name;
    var stateMap = {
      invited: gaActions.manageSeriesInvitedStateAction,
      progress: gaActions.manageSeriesStartedStateAction,
      missed: gaActions.manageSeriesMissedDeadlineStateAction,
      passed: gaActions.manageSeriesPassedStateAction,
      failed: gaActions.manageSeriesFailedStateAction
    };
    var userRole = trainerPrivilege.roles();

    $scope.canRemindTrainees = userRole.canRemindTrainees;
    $scope.canResetTrainees = userRole.canResetTrainees;

    $scope.$watch('homeState.selectedItem', function () {
      if ($scope.homeState.selectedItem.type === "series") {
        setup($scope.homeState.selectedItem.id);
      }
    });

    function setup(seriesId, cb) {
      homeResource.getSeriesDetails(seriesId, function (result) {
        setState(result);
        if (cb) {
          cb();
        }
      }, function (err) {
        setState();
        if (cb) {
          cb();
        }
      });
    }

    $scope.gotoSeries = function () {
      trackingService.trackEvent(gaPageName, gaActions.openSeriesAction);
      $location.path('/TMS/Series/' + $scope.homeState.selectedItem.id);
    };

    $scope.traineeStateClick = function (state) {
      var filter = state;
      var subFilter = 'all';
      if (~['passed', 'failed'].indexOf(filter)) {
        subFilter = filter;
        filter = 'completed';
      }
      trackingService.trackEvent(gaPageName, stateMap[state]);
      $location.path('/TMS/Series/' + $scope.homeState.selectedItem.id + '/trainees').search('f', filter).search('gf', subFilter);
    };

    $scope.manageTrainees = function () {
      trackingService.trackEvent(gaPageName, gaActions.manageSeriesTraineesAction);
      $location.path('/TMS/Series/' + $scope.homeState.selectedItem.id + '/trainees');
    };

    $scope.courseClick = function (courseId) {
      trackingService.trackEvent(gaPageName, gaActions.filterByCourseAction);
      $scope.clearSearch();
      $scope.selectItemById(courseId);
    };

    function setState(state) {
      if (state) {
        viewState = state;
      } else {
        viewState = {
          description: null,
          canGoToSeries: false,
          courseFailureEnforced: false,
          sequenceEnforced: false,
          sequenceEnforcedStr: "No",
          courses: [],
          trainees: {
            invited: 0,
            invitedRemind: 0,
            missedCompletionDeadline: 0,
            inProgress: 0,
            inProgressRemind: 0,
            failed: 0,
            passed: 0,
            numOfTrainees: 0
          }
        };
      }

      viewState.canDeleteSeries = userRole.canEditCourses;
      $scope.viewState = viewState;
    }

    $scope.deleteSeries = function (params) {
      if (!params.id) return;
      $rootScope.$broadcast('seriesDeletionRequestedEvent', params);
    };

    $scope.$on('seriesDeletionConfirmedEvent', function (event, seriesId, cb) {
      trackingService.trackEvent(gaPageName, gaActions.deleteSeriesAction);

      homeResource.deleteSeries(seriesId, function () {
        $rootScope.$broadcast('seriesDeleted', seriesId);
        (cb || angular.noop)();
      }, function (err) {
        (cb || angular.noop)();
      });
    });

    $scope.showTraineesAction = function (state) {

      if (!$scope.viewState || !$scope.viewState.trainees) {
        return false;
      }

      return $scope.viewState.trainees[state] > 0;
    };

    $scope.canRemind = function (state) {
      if (!$scope.showTraineesAction(state)) {
        return false;
      }

      var key = state + 'Remind';
      return $scope.viewState.trainees[key] > 0;
    };

    $scope.remindTrainees = function (state) {
      if (state != 'invited' && state != 'inProgress') {
        return;
      }

      if (!$scope.canRemind(state)) {
        return;
      }

      var key = state + 'Remind';
      var count = $scope.viewState.trainees[key];
      var totalCount = $scope.viewState.trainees[state];

      trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.pokeRemindSeriesTrainees);

      $scope.$broadcast('traineesToRemindEvent', count, {
        state: state,
        totalCount: totalCount
      });
    };

    $scope.$on('remindTraineesConfirmEvent', function (event, data, cb) {
      var state = data.state;
      var seriesId = $scope.homeState.selectedItem.id;
      seriesTraineesResource.pokeRemindSeriesTraineesByState(seriesId, state, function () {
        setup(seriesId, cb);
      }, cb);
    });

    $scope.resetTrainees = function (state) {
      if (state != 'missedCompletionDeadline'
        && state != 'failed'
        && state != 'passed') {
        return;
      }

      if (!$scope.showTraineesAction(state)) {
        return;
      }

      var count = $scope.viewState.trainees[state];
      trackingService.trackEvent(trackingService.pages.trainerHome.name, trackingService.pages.trainerHome.actions.resetSeriesTrainees);

      $scope.$broadcast('seriesBulkResetRequested', count, {
        state: state
      });
    };

    $scope.$on("seriesBulkResetConfirmed", function (event, data, cb) {
      var state = data.state;
      var seriesId = $scope.homeState.selectedItem.id;
      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      seriesTraineesResource.resetSeriesTraineesByState(seriesId, state, dateString, function () {
        setup(seriesId, cb);
      }, cb);
    });

    setState();
  }

})();
